import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagFavoritesLimitReached = () => {
  const interactionType = {
    eventType: TRACKING_ACTION.INTERACTION,
    interaction:
      TRACKING_INTERACTION.FAVORITES_AND_WATCHLIST.FAVORITES_LIMIT_REACHED,
  };
  const userInteractionEvent = createUserInteraction(interactionType);
  trackEvent(userInteractionEvent);
};
